// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */

.offer-container {
  max-width: 900px;
  margin: 50px;
  font-family: sans-serif;
}

/* Title */

.offer-title {
  margin-bottom: 20px;
}

/* Add Button */

.offer-add-btn {
  background: #4f46e5;
  color: #fff;
  border: none;
  padding: 12px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: 0.2s;
}

.offer-add-btn:hover {
  background: #4338ca;
  transform: translateY(-1px);
}

/* Editor Card */

.editor-card {
  margin-top: 20px;
  padding: 20px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

/* Buttons row */

.editor-actions {
  margin-top: 15px;
}

/* Shared button */

.btn {
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  margin-right: 10px;
  transition: 0.2s;
}

/* Save */

.save-btn {
  background: #16a34a;
  color: white;
}

.save-btn:hover {
  background: #15803d;
}

/* Cancel */

.cancel-btn {
  background: #e5e7eb;
}

.cancel-btn:hover {
  background: #d1d5db;
}

/* Saved Offers */

.offers-list {
  margin-top: 30px;
}

.saved-title {
  margin-bottom: 10px;
  color: #374151;
  font-size: 23px;
}

/* Offer Card */

.offer-card {
  background: #ffffff;
  padding: 18px;
  margin-top: 12px;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  transition: 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.offer-card:hover {
  transform: translateY(-3px);
}

/* ===== MODAL FIX ===== */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.55);

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  width: 420px;
  max-width: 90%;

  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);

  animation: popup 0.2s ease;
}

@keyframes popup {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-input {
  width: 100%;
  padding: 10px;
  margin-top: 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  margin-bottom: 20px;
}

.modal-actions {
  margin-top: 18px;
}

/* Button link text */
.button-link {
  margin-top: 8px;
  color: #4b5563;
  word-break: break-all;
}

/* Optional CTA style */
.global-cta-btn {
  background: #4f46e5;
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 600;
}

/* Editor modal should be wider */

.editor-modal {
  width: 750px;
  max-width: 95%;
}

.card-actions {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.edit-btn {
  background: #2563eb;
  color: white;
}

.edit-btn:hover {
  background: #1d4ed8;
}

.delete-btn {
  background: #dc2626;
  color: white;
}

.delete-btn:hover {
  background: #b91c1c;
}

.offers-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.edit-all-btn {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.edit-all-btn:hover {
  background-color: #125aa0;
}

.offer-simple-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.offer-list-item {
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.offer-description {
  margin-top: 6px;
  color: #555;
}
.modal.editor-modal {
  width: 700px;
  max-height: 95vh; /* Prevent full screen growth */
  display: flex;
  flex-direction: column;
}

.editor-scroll-section {
  flex: 1 1;
  max-height: 220px; /* Fixed visible scroll area */
  overflow-y: scroll; /* Always show scrollbar */
  margin-top: 15px;
  padding-right: 8px;
  border-top: 1px solid #e5e7eb; /* Visual separator */
  border-bottom: 1px solid #e5e7eb;
}
/* Custom Scrollbar */
.editor-scroll-section::-webkit-scrollbar {
  width: 8px;
}

.editor-scroll-section::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 8px;
}

.editor-scroll-section::-webkit-scrollbar-thumb {
  background: #9ca3af;
  border-radius: 8px;
}

.editor-scroll-section::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

.modal.editor-modal.button-modal {
  width: 500px;
}
button.btn.save-btn.button-modal {
  margin-top: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/features/OfferPage/offerpagestyle.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,UAAU;;AAEV;EACE,mBAAmB;AACrB;;AAEA,eAAe;;AAEf;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;;AAElB;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;;AAET;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;;AAEf;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;;AAE1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,+BAA+B;;EAE/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;;EAEd,2CAA2C;;EAE3C,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;;AAEjC;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB,EAAE,+BAA+B;EACjD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,iBAAiB,EAAE,8BAA8B;EACjD,kBAAkB,EAAE,0BAA0B;EAC9C,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B,EAAE,qBAAqB;EACpD,gCAAgC;AAClC;AACA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* Container */\n\n.offer-container {\n  max-width: 900px;\n  margin: 50px;\n  font-family: sans-serif;\n}\n\n/* Title */\n\n.offer-title {\n  margin-bottom: 20px;\n}\n\n/* Add Button */\n\n.offer-add-btn {\n  background: #4f46e5;\n  color: #fff;\n  border: none;\n  padding: 12px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: 0.2s;\n}\n\n.offer-add-btn:hover {\n  background: #4338ca;\n  transform: translateY(-1px);\n}\n\n/* Editor Card */\n\n.editor-card {\n  margin-top: 20px;\n  padding: 20px;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n/* Buttons row */\n\n.editor-actions {\n  margin-top: 15px;\n}\n\n/* Shared button */\n\n.btn {\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  margin-right: 10px;\n  transition: 0.2s;\n}\n\n/* Save */\n\n.save-btn {\n  background: #16a34a;\n  color: white;\n}\n\n.save-btn:hover {\n  background: #15803d;\n}\n\n/* Cancel */\n\n.cancel-btn {\n  background: #e5e7eb;\n}\n\n.cancel-btn:hover {\n  background: #d1d5db;\n}\n\n/* Saved Offers */\n\n.offers-list {\n  margin-top: 30px;\n}\n\n.saved-title {\n  margin-bottom: 10px;\n  color: #374151;\n  font-size: 23px;\n}\n\n/* Offer Card */\n\n.offer-card {\n  background: #ffffff;\n  padding: 18px;\n  margin-top: 12px;\n  border-radius: 10px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);\n  transition: 0.2s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.offer-card:hover {\n  transform: translateY(-3px);\n}\n\n/* ===== MODAL FIX ===== */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  background: rgba(0, 0, 0, 0.55);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  z-index: 9999;\n}\n\n.modal {\n  background: #fff;\n  padding: 25px;\n  border-radius: 12px;\n  width: 420px;\n  max-width: 90%;\n\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n\n  animation: popup 0.2s ease;\n}\n\n@keyframes popup {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.modal-input {\n  width: 100%;\n  padding: 10px;\n  margin-top: 12px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  margin-bottom: 20px;\n}\n\n.modal-actions {\n  margin-top: 18px;\n}\n\n/* Button link text */\n.button-link {\n  margin-top: 8px;\n  color: #4b5563;\n  word-break: break-all;\n}\n\n/* Optional CTA style */\n.global-cta-btn {\n  background: #4f46e5;\n  color: #fff;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n/* Editor modal should be wider */\n\n.editor-modal {\n  width: 750px;\n  max-width: 95%;\n}\n\n.card-actions {\n  margin-top: 15px;\n  display: flex;\n  gap: 10px;\n}\n\n.edit-btn {\n  background: #2563eb;\n  color: white;\n}\n\n.edit-btn:hover {\n  background: #1d4ed8;\n}\n\n.delete-btn {\n  background: #dc2626;\n  color: white;\n}\n\n.delete-btn:hover {\n  background: #b91c1c;\n}\n\n.offers-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.edit-all-btn {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.edit-all-btn:hover {\n  background-color: #125aa0;\n}\n\n.offer-simple-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.offer-list-item {\n  padding: 12px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.offer-description {\n  margin-top: 6px;\n  color: #555;\n}\n.modal.editor-modal {\n  width: 700px;\n  max-height: 95vh; /* Prevent full screen growth */\n  display: flex;\n  flex-direction: column;\n}\n\n.editor-scroll-section {\n  flex: 1;\n  max-height: 220px; /* Fixed visible scroll area */\n  overflow-y: scroll; /* Always show scrollbar */\n  margin-top: 15px;\n  padding-right: 8px;\n  border-top: 1px solid #e5e7eb; /* Visual separator */\n  border-bottom: 1px solid #e5e7eb;\n}\n/* Custom Scrollbar */\n.editor-scroll-section::-webkit-scrollbar {\n  width: 8px;\n}\n\n.editor-scroll-section::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 8px;\n}\n\n.editor-scroll-section::-webkit-scrollbar-thumb {\n  background: #9ca3af;\n  border-radius: 8px;\n}\n\n.editor-scroll-section::-webkit-scrollbar-thumb:hover {\n  background: #6b7280;\n}\n\n.modal.editor-modal.button-modal {\n  width: 500px;\n}\nbutton.btn.save-btn.button-modal {\n  margin-top: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
